module.exports = __webpack_public_path__ + "img/banner_icon.27913d71.png";